import { useState, useEffect } from "react";
import { Collapse, Spin } from "antd";
import { connect } from "react-redux";

import API from "scripts/api";
import Icons from "scripts/icons";

import LoadMore from "components/loadmore";
import Empty from "pages/empty";

const Component = ({ user }) => {
	const initialState = {
		list: [],
	};
	const [state, setState] = useState(initialState);
	const { list, loaded, loading, loadMore, page } = state;

	const handleData = (params) => {
		if (!loading) {
			setState((prevState) => ({ ...prevState, loading: true }));

			params.pageSize = 12;

			API.notification
				.list(params)
				.then(({ data, meta: { currentPage, perPage, total } }) => {
					setState((prevState) => ({
						...prevState,
						loaded: true,
						loading: false,
						loadMore: total > currentPage * perPage,
						list: [...list, ...data],
						page: currentPage,
					}));
				})
				.catch(() => {
					setState((prevState) => ({ ...prevState, loading: false }));
				});
		}
	};

	const handleLoadmore = () => {
		handleData({ page: page + 1 });
	};

	const handleRead = (id) => {
		API.notification
			.select(id)
			.then(() => {})
			.catch(() => {});
	};

	const componentDidMount = () => {
		handleData({ user: user.id });
	};

	useEffect(componentDidMount, []);

	return loaded ? (
		<div className="panel-notifications">
			{loaded ? (
				list.length ? (
					<>
						<Collapse>
							{list.map(({ id, informType, body, title }) => (
								<Collapse.Panel
									key={id}
									header={
										<>
											{informType === "info" ? (
												<Icons.CircleInfo className={`square ${informType}`} />
											) : informType === "success" ? (
												<Icons.CircleTick className={`square ${informType}`} />
											) : informType === "warning" ? (
												<Icons.CircleWarning
													className={`square ${informType}`}
												/>
											) : (
												<Icons.CircleDanger
													className={`square ${informType}`}
												/>
											)}
											<div onClick={() => handleRead(id)}>{title}</div>
										</>
									}
									children={
										<div dangerouslySetInnerHTML={{ __html: body }}></div>
									}
								/>
							))}
						</Collapse>
						{loadMore && (
							<LoadMore onScreen={handleLoadmore} loading={loading} />
						)}
					</>
				) : (
					<Empty />
				)
			) : (
				<Spin />
			)}
		</div>
	) : (
		<Spin className="page-loading" />
	);
};

export default connect((state) => {
	return {
		user: state.user,
	};
})(Component);
